// extracted by mini-css-extract-plugin
module.exports = {"centreThumbnail":"styles_centreThumbnail__2sSrh"};